<fieldset>
  <label *ngIf="label" class="col-form-label label-common">{{label}}<span class="text-danger">{{required ? ' *' : ''}}</span></label>
  <div class="input-group">
    <input class="form-control disable-click" [attr.id]="'input-date-'+id"
           [formControl]="datePickerControl"
           [placeholder]="placeholder"
           (ngModelChange)="onValueChange($event)"
           #dp="bsDatepicker"
           bsDatepicker
           [bsConfig]="bsConfig"
           [isOpen]="isOpen"
           [placement]="placement"
           [outsideClick]="true"
           [dateCustomClasses]="dateCustomClasses"
           [attr.disabled]="isDisableButton ? 'disabled' : null"
           [class.is-invalid]="parentControl && parentControl.touched && parentControl.invalid && validationMessage"/>
    <span [ngClass]="displayButtonRemove === true ? 'display-button-remove' : ''"
      class="icon-remove" [attr.id]="'clear-date-'+id" *ngIf="datePickerControl && datePickerControl.value"
      (click)="!disabledClearButton && onClearDate()">
      <c-icon [name]="'remove'"></c-icon>
    </span>
    <div class="input-group-append " (click)="dp.toggle()" [attr.id]="'date-picker-calender-'+id" [ngClass]="{'disable-click': isDisableButton}">
      <span class="btn btn-datepicker">
        <i class="fa fa-calendar"></i>
      </span>
    </div>

    <div class="invalid-feedback"
         *ngIf="parentControl && parentControl.touched && parentControl.invalid && validationMessage" [attr.id]="'picker-' + id + '-invalid'">
      {{validationMessage}}
    </div>
  </div>
</fieldset>
<ng-template #xicon>
  <svg width="100%" height="100%" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
       x="0px" y="0px"
       viewBox="0 0 47.971 47.971" style="enable-background:new 0 0 47.971 47.971;" xml:space="preserve">
    <g>
      <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
                                c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
                                C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
                                s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"/>
    </g>
  </svg>
</ng-template>
